import { semesters as semestersServices } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../../../../../../../../common/error/state';
import logger from '../../../../../../../../../../common/services/logService';
import Types from '../types';

export const fetchListStart = () => ({
  type: Types.FETCH_LIST_START,
});

export const fetchListEnd = () => ({
  type: Types.FETCH_LIST_END,
});

export const setList = list => ({
  type: Types.SET_LIST,
  payload: list,
});

export default semesterId => async dispatch => {
  try {
    dispatch(fetchListStart());
    const { data } =
      await semestersServices.getStageGradebookDisplays(semesterId);
    dispatch(setList(data));
  } catch (error) {
    logger.log(error);
    if (error.response) {
      dispatch(ErrorsActions.addError(error.response.data.message));
    }
  } finally {
    dispatch(fetchListEnd());
  }
};
